import React from 'react';
import Card from '../../../../muiComponents/Card';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';

const LoadingSection = () => {
    return (
        <Card style={{ minHeight: '250px', padding: '10px 20px' }}>
            <LoadingPlaceholder variant='text' height={250} width={'100%'} />
        </Card>
    );
};

export default LoadingSection;
